import React from 'react';
import { Box, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { sectionConfig } from '../constants/formConfig';
import { isSectionComplete } from '../utils/validation';

/**
 * Desktop/Tablet Section Navigation Component
 * Displays form progress and allows quick navigation between sections
 */
function SectionNav({
  computedMissingFields,
  classes,
  hasSubmitted,
  onSubmit,
  isButtonBusy,
  value,
  certificate,
  isEmailValid
}) {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const getSectionStatus = (section) => {
    // Check if section is complete (real-time positive feedback)
    const isComplete = isSectionComplete(section, value, certificate, isEmailValid);

    if (isComplete) {
      return { status: 'complete', missingCount: 0 };
    }

    // Only show error state after first submit attempt
    if (!hasSubmitted) {
      return { status: 'pending', missingCount: 0 };
    }

    const missingCount = section.fields.filter(field => computedMissingFields[field]).length;
    return { status: 'error', missingCount };
  };

  return (
    <Box className={clsx('test', classes.sectionNav)}>
      <Typography className={classes.sectionNavTitle}>填寫進度</Typography>
      {sectionConfig.map((section) => {
        const { status, missingCount } = getSectionStatus(section);
        const itemClass = `${classes.sectionNavItem} ${
          status === 'complete' ? classes.sectionNavItemComplete :
          status === 'error' ? classes.sectionNavItemError : ''
        }`;
        const iconClass = `${classes.sectionNavIcon} ${
          status === 'complete' ? classes.sectionNavIconComplete :
          status === 'error' ? classes.sectionNavIconError :
          classes.sectionNavIconPending
        }`;

        return (
          <Box
            key={section.id}
            className={itemClass}
            onClick={() => scrollToSection(section.id)}
          >
            <Box className={iconClass}>
              {status === 'complete' ? '✓' :
               status === 'error' ? missingCount :
               '○'}
            </Box>
            <Typography className={classes.sectionNavLabel}>
              {section.label}
            </Typography>
          </Box>
        );
      })}
      {/* Submit Button */}
      <Box
        className={classes.navSubmitButton}
        onClick={onSubmit}
        disabled={isButtonBusy}
        component="button"
        type="button"
      >
        <Typography className={classes.navSubmitButtonLabel}>
          送出
        </Typography>
      </Box>
    </Box>
  );
}

export default SectionNav;
